export const LOGIN_PATH = "/login";
export const DASHBOARD_PATH = "/dashboard";
export const COMING_SOON_PATH = "/comingsoon";
